module.exports = __webpack_public_path__ + "img/DDLRLOC.dece2546.svg";